import useContactInfosApi from "../../profiles/data/use_contact_infos_api";
import { CONTACT_OWNER_TYPE } from "./media_outlet_context_management";

// Media Outlet's contact-info action hook — a thin binding of the shared generic hook to this
// engine's owner id/type, so the outlet's edit surface (and its existing test) keeps its own
// signature unchanged.
const useMediaOutletContactInfosApi = ({ mediaOutletId, silentReload, setGeneralError, setIsUpdating, isUpdating }) =>
  useContactInfosApi({
    contactOwnerId: mediaOutletId,
    contactOwnerType: CONTACT_OWNER_TYPE,
    silentReload,
    setGeneralError,
    setIsUpdating,
    isUpdating,
  });

export default useMediaOutletContactInfosApi;
